import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-related-case-studies",
    templateUrl: "./related-case-studies.component.html",
    styleUrls: ["./related-case-studies.component.scss"],
})
export class RelatedCaseStudiesComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    sectionTitle: sectionTitleContent[] = [
        {
            title: "More Sites You Might Like",
        },
    ];
    singleProjectsBox: singleProjectsContent[] = [
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/img8.jpg",
            imgClass: "",
            title: "Upstream Data Foundation",
            subTitle: "",
            link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation",
        },
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/img5.jpg",
            imgClass: "",
            title: "Upstream Data Foundation Operations",
            subTitle: "",
            link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation_Operations",
        },
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/img1.jpg",
            imgClass: "",
            title: "Upstream Data Governance Services",
            subTitle: "",
            link: "https://wiki.na.xom.com/index.php/Upstream_Data_Foundation_Service",
        },
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/collibra.jpeg",
            imgClass: "collibra",
            title: "Collibra",
            subTitle: "",
            link: "https://em.collibra.com/dashboard",
        },
        {
            icon: "bx bx-plus",
            img: "assets/img/projects/DataDash.jpeg",
            imgClass: "",
            title: "DataDash",
            subTitle: "",
            link: "https://datadash.xom.cloud/#/",
        },
    ];
}
class sectionTitleContent {
    title: string;
}
class singleProjectsContent {
    icon: string;
    img: string;
    imgClass: string;
    title: string;
    subTitle: string;
    link: string;
}
